import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { LossAndDamageClaimPrintFormInfo } from '../../types';

export interface GetLADClaimPrintFormRequestParams {
  ClaimKeys: string;
}

export const getLADClaimPrintFormAPI = (params: GetLADClaimPrintFormRequestParams) => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetMultiplePrintForm`,
    method: 'get',
    params,
  });
};

export type LADClaimPrintFormResponse = LossAndDamageClaimPrintFormInfo[];

export const fetchLADClaimPrintForm = async (
  params: GetLADClaimPrintFormRequestParams,
): Promise<LADClaimPrintFormResponse> => {
  const response: AxiosResponse<LADClaimPrintFormResponse> = await getLADClaimPrintFormAPI(params);
  return response.data;
};
